import { Business } from "@/types/BusinessInterface";
import { LotInterface } from "@/types/LotInterface";

export function getBusinessColorFromLot(
  lot: LotInterface | null,
  businesses: Business[]
): string {
  const defaultColor = "#8f00ff";

  if (!lot) return defaultColor;

  if (lot.ownershipId && typeof lot.ownershipId === "object") {
    return (lot.ownershipId as Business).branding?.color ?? defaultColor;
  }

  const matchedBusiness = businesses.find(
    (business) =>
      lot.ownershipId &&
      typeof lot.ownershipId === "string" &&
      business._id === lot.ownershipId
  );

  return matchedBusiness?.branding?.color ?? defaultColor;
}
